import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {from, Observable} from 'rxjs';
import {FirestoreService} from '../../../services/firestore.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    standalone: false,
  host: {
    class: 'row flex-grow-1'
  }
})
export class HomeComponent {
  homeHeader$: Observable<string>;
  homeSubheader$: Observable<string>;
  navBar$: Observable<Object>;
  navBar: Iterable<any> = [];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
    private firestoreService: FirestoreService
	) {
    this.homeHeader$ = this.firestoreService.getSiteText('homeHeader');
    this.homeSubheader$ = this.firestoreService.getSiteText('homeSubheader');
    this.navBar$ = this.firestoreService.getSiteNav('navBar');
    this.navBar$.subscribe((value: any) => { this.navBar = value });
  }

	navigate(url: string) {
		 this.router.navigate([url]);
	}

  example() {
    alert("This is an example function.");
  }
}
